import { FeatureFlag } from '@ps/web-core-enums';
import { usePauseValidator } from '@ps/web-shared-components';
import React, { useMemo } from 'react';
import { useField, useForm } from 'react-final-form';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import PhoneNumberInput from '@swf/components/PhoneNumberInput/PhoneNumberInput';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import { countryInitialName } from '@swf/core/utils/phoneVerification';

import DialingCode from '../../../../../DialingCode/DialingCode';
import TextInput from '../../../../../TextInput/TextInput';

import {
  TXTCLI_Optional,
  TXTWCL_CompanyXs_address,
  TXTWCL_CompanyXs_phone,
  TXTWCL_Company_name
} from './EmployerFields.messages.json';
import { inputWrapper } from './EmployerFields.scss';

const EmployerFields = () => {
  const { formatMessage } = useIntl();
  const rmfEmployerInfo = useFeature(FeatureFlag.RmfEmployerInfo);
  const form = useForm();
  const { values } = form.getState();
  const userCountry = useSelector(select.account.getCountry);
  const {
    input: { value: companyName }
  } = useField('occupationCompanyName', { subscription: { value: true } });
  const {
    input: { value: companyPhone }
  } = useField('occupationCompanyPhone', { subscription: { value: true } });
  const {
    input: { value: companyAddress }
  } = useField('occupationCompanyAddress', { subscription: { value: true } });
  usePauseValidator();

  const country = useMemo(() => {
    if (values.occupationDialingCode) return values.occupationDialingCode;
    if (values.occupationCompanyPhone) {
      return countryInitialName(values.occupationCompanyPhone, userCountry);
    }
    return userCountry;
  }, [values, userCountry]);

  return rmfEmployerInfo ? (
    <>
      <TextInput
        value={companyName}
        id="occupationCompanyName"
        label={TXTWCL_Company_name}
        placeholder={formatMessage(TXTCLI_Optional)}
      />
      <div className={inputWrapper}>
        <DialingCode fieldName="occupationDialingCode" inputNumberName="occupationCompanyPhone" />
        <PhoneNumberInput
          placeholder={formatMessage(TXTCLI_Optional)}
          autocompletePattern="none"
          hideFormatInLabel
          hidePlaceholder={false}
          label={TXTWCL_CompanyXs_phone}
          value={companyPhone}
          fieldName="occupationCompanyPhone"
          phoneFormatCountry={country}
          required={false}
        />
      </div>
      <TextInput
        value={companyAddress}
        id="occupationCompanyAddress"
        label={TXTWCL_CompanyXs_address}
        placeholder={formatMessage(TXTCLI_Optional)}
      />
    </>
  ) : null;
};

export default EmployerFields;
